import { render } from "./customerView.vue?vue&type=template&id=2213d9b5&scoped=true"
import script from "./customerView.vue?vue&type=script&lang=js"
export * from "./customerView.vue?vue&type=script&lang=js"

import "./customerView.vue?vue&type=style&index=0&id=2213d9b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2213d9b5"]])

export default __exports__